import { Component, OnInit, OnDestroy } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { RootState } from '../../root-store/root.state';
import { seLogoClick, seSetToolbarDescription1, seSetToolbarInfo } from '../../root-store/root.actions';
import { MainToolbarHeaderInfo } from './se-header-info/se-header-info.component';
import { cloneDeep } from 'lodash-es';
import { ThirdPartSupportService } from '../../services/third-part-support.service';

@Component({
    selector: 'se-header-toolbar',
    templateUrl: './se-header-toolbar.component.html',
    styleUrls: ['./se-header-toolbar.component.scss'],
    standalone: false
})
export class SeHeaderToolbarComponent implements OnDestroy, OnInit {
    info1: MainToolbarHeaderInfo | undefined;
    info2: MainToolbarHeaderInfo| undefined;

    private storeSubscriber: Subscription | undefined;

    constructor(
        private actions: Actions,
        private store: Store<RootState>,
        private thirdPartService: ThirdPartSupportService
    ) {}

    ngOnInit() {
        this.storeSubscriber = this.actions
            .pipe(ofType(seSetToolbarInfo))
            .subscribe(({ info1, info2 }) => this.setInfo(info1, info2));
        this.storeSubscriber = this.actions
            .pipe(ofType(seSetToolbarDescription1))
            .subscribe(({ description1 }) => {
                if (this.info1) {
                    const newInfo1 = cloneDeep(this.info1);
                    newInfo1.mainDescription = description1;
                    this.setInfo(newInfo1, this.info2);
                }
            });
    }

    ngOnDestroy() {
        this.info2 = undefined;
        this.info1 = undefined;

        this.storeSubscriber?.unsubscribe();
    }

    async onLogoClick() {
        if (!this.thirdPartService.isThirdPartPage())
            this.store.dispatch(seLogoClick());
    }

    private setInfo(info1?: MainToolbarHeaderInfo, info2?: MainToolbarHeaderInfo) {
        setTimeout(() => {
            this.info1 = info1;
            this.info2 = info2;
        });
    }
}
